module.exports = __webpack_public_path__ + "ccf4be18ec07143dd322c94279bd865f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile_images/header_logo.png
// module id = 145
// module chunks = 0 1 2 3 4